import { BackOfficeField } from "@closerplatform/spinner-openapi";
import React from "react";
import { config } from "@fidget/common/config/config";
import { IGuest } from "../../models/base/Guest";
import { Plugin, PluginContext, ProcessedField } from "../plugin";

export class SalesforcePlugin implements Plugin {
  public static readonly PLUGIN_ID = "orange_salesforce";
  public readonly id = SalesforcePlugin.PLUGIN_ID;

  private context?: PluginContext;

  onGuestField = (field: BackOfficeField, guest: IGuest): ProcessedField => {
    if (this.context && field.key === "dopUserId") {
      return {
        ...field,
        displayKey: "Salesforce",
        displayValue: (
          <a
            href={"javascript:void()"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.navigateToSObject(field.value, guest.id, this.context?.currentAgentId || "");
            }}
          >
            {guest.displayName}
          </a>
        )
      };
    }
    return field;
  };

  configure = (context: PluginContext, pluginConfig: any) => {
    this.context = context;
  };

  private navigateToSObject = (dopUserId: string, customerId: string, adviserId: string) => {
    const apiUrl = `${config.services.tangerine.baseUrl}/${this.context?.orgId}/orange_salesforce/open`;
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "X-Api-Key": this.context?.currentAgentApiKey || "",
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify({ dopUserId, customerId, adviserId })
    });
  };
}
